var Docs, Fuse,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Fuse = require('fuse.js');

require('es6-promise').polyfill();

require('isomorphic-fetch');


/**
 * Provides methods for building the documentation menu
 *
 * @type {Docs}
 */

module.exports = Docs = (function() {

  /**
   * A map of key codes
   *
   * @type {object}
   */
  var keyCodes, menuItem, menuPane, navToggle, searchInput, searchResultsPane;

  keyCodes = {
    ESC: 27
  };


  /**
   * The documentation link in the main menu
   *
   * @type {HTMLElement}
   */

  menuItem = document.querySelector('.nav--main-docs-link');


  /**
   * The documentation link in the main menu
   *
   * @type {HTMLElement}
   */

  navToggle = document.querySelector('.nav--main-mobile-nav-link');


  /**
   * The navigation pane containing the documentation menu
   *
   * @type {HTMLElement}
   */

  menuPane = document.querySelector('.nav--docs');


  /**
   * The search input
   *
   * @type {HTMLElement}
   */

  searchInput = document.querySelector('#search');


  /**
   * The search results pane
   *
   * @type {HTMLElement}
   */

  searchResultsPane = document.querySelector('.nav--docs-search-results');


  /**
   * Start your engines!
   *
   * @return {Docs}
   */

  function Docs() {
    this.renderNav = bind(this.renderNav, this);
    this.search = bind(this.search, this);
    this.registerNavListeners();
    this.registerSearchListeners();
    this.renderNav();
  }


  /**
   * Register listeners to handle search input
   */

  Docs.prototype.registerSearchListeners = function() {
    return searchInput.addEventListener('keyup', (function(_this) {
      return function(evt) {
        var key;
        key = evt.keyCode || evt.which;
        if (searchInput.value && key !== keyCodes.ESC) {
          document.body.classList.add('search--open');
          return _this.search(searchInput.value);
        } else {
          document.body.classList.remove('search--open');
          return searchInput.value = '';
        }
      };
    })(this));
  };


  /**
   * Search documentation and display results
   *
   * @param  {string} term The search term
   *
   * @return {Promise}
   */

  Docs.prototype.search = function(term) {
    return this.getDocs().then(function(docs) {
      var a, fuse, h3, i, key, len, li, options, p, result, results, results1, searchable;
      searchable = [];
      searchable.push.apply(searchable, docs.items);
      delete docs.items;
      for (key in docs) {
        if (docs[key].items != null) {
          searchable.push.apply(searchable, docs[key].items);
        }
      }
      options = {
        threshold: 0.6,
        keys: [
          {
            name: 'title',
            weight: 1
          }, {
            name: 'description',
            weight: 0.7
          }, {
            name: 'content',
            weight: 0.5
          }, {
            name: '_url',
            weight: 0.5
          }
        ]
      };
      fuse = new Fuse(searchable, options);
      results = fuse.search(term);
      searchResultsPane.innerHTML = '';
      results1 = [];
      for (i = 0, len = results.length; i < len; i++) {
        result = results[i];
        li = document.createElement('li');
        li.classList.add('nav--docs-search-results-item');
        a = document.createElement('a');
        a.href = result._url;
        h3 = document.createElement('h3');
        h3.innerHTML = result.title;
        a.appendChild(h3);
        if (result.description != null) {
          p = document.createElement('p');
          p.innerHTML = result.description;
          a.appendChild(p);
        }
        li.appendChild(a);
        results1.push(searchResultsPane.appendChild(li));
      }
      return results1;
    });
  };


  /**
   * Register listeners for opening and closing the documentation navigation
   */

  Docs.prototype.registerNavListeners = function() {
    var listener;
    listener = function(evt) {
      evt.preventDefault();
      if (document.body.classList.contains('docs--open')) {
        document.body.classList.remove('docs--open');
        document.body.classList.remove('search--open');
        return searchInput.value = '';
      } else {
        return document.body.classList.add('docs--open');
      }
    };
    menuItem.addEventListener('click', listener);
    navToggle.addEventListener('click', listener);
    return document.addEventListener('keydown', function(evt) {
      var key, open;
      key = evt.keyCode || evt.which;
      open = document.body.classList.contains('docs--open');
      if (open && key === keyCodes.ESC) {
        return document.body.classList.remove('docs--open');
      }
    });
  };


  /**
   * Renders the navigation in the sidebar
   */

  Docs.prototype.renderNav = function() {
    return this.getDocs().then(function(docs) {
      var key, results1;
      docs.main = {
        items: docs.items
      };
      results1 = [];
      for (key in docs) {
        results1.push((function(key) {
          var i, len, list, lists, results2;
          lists = document.querySelectorAll(".nav--docs-" + key);
          results2 = [];
          for (i = 0, len = lists.length; i < len; i++) {
            list = lists[i];
            results2.push((function(list) {
              var item, j, len1, ref, results3;
              if ((list == null) || (docs[key] == null)) {
                return;
              }
              docs[key].items.sort(function(a, b) {
                if (a.seq != null) {
                  return a.seq - b.seq;
                }
                if (a.title < b.title) {
                  return -1;
                }
                if (a.title > b.title) {
                  return 1;
                }
                return 0;
              });
              ref = docs[key].items;
              results3 = [];
              for (j = 0, len1 = ref.length; j < len1; j++) {
                item = ref[j];
                results3.push((function(item) {
                  var a, li, url;
                  li = document.createElement('li');
                  a = document.createElement('a');
                  url = "" + window.baseUrl + item._url;
                  a.href = url;
                  a.innerHTML = item.title;
                  if (("" + url) === window.location.pathname) {
                    a.classList.add('active');
                  }
                  li.appendChild(a);
                  return list.appendChild(li);
                })(item));
              }
              return results3;
            })(list));
          }
          return results2;
        })(key));
      }
      return results1;
    });
  };


  /**
   * Retrieve the package index JSON, and cache it
   * in local storage for five minutes, returning
   * the object in a Promise
   *
   * @return {Promise}
   */

  Docs.prototype.getDocs = function() {
    return new Promise(function(resolve, reject) {
      var json, timestamp, updatedAt;
      updatedAt = parseInt(localStorage.getItem('documentation_updated_at'));
      timestamp = new Date().getTime();
      if ((updatedAt + 300) > timestamp) {
        json = localStorage.getItem('documentation');
        resolve(JSON.parse(json));
        return;
      }
      return fetch("" + window.baseDomain + window.baseUrl + "/docs.json").then(function(response) {
        return response.json();
      }).then(function(response) {
        localStorage.setItem('documentation', JSON.stringify(response.docs));
        localStorage.setItem('documentation_updated_at', timestamp);
        return resolve(response.docs);
      })["catch"](function(err) {
        return reject(err);
      });
    });
  };

  return Docs;

})();

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
